import type { Namespace } from '../types';

// Cockpit / analytics (R-069/D-071 — SEN-AN). DE drafted — queued for review.
export const cockpit = {
  title: { de: 'Cockpit', en: 'Cockpit' },
  desc: {
    de: 'Farm-KPIs mit Drilldown, Ereignis-Trends und Aktivitätsverlauf.',
    en: 'Farm KPIs with drill-down, event trends and the activity timeline.',
  },

  // KPI tiles
  tileIncidents: { de: 'Störungen offen', en: 'Incidents open' },
  tileAlarms: { de: 'Alarme', en: 'Alarms' },
  // The SOC room rollup's `in_band` only means "reported in the last 5 min" — it is
  // not judged against a band, so the tile says what it knows.
  tileRooms: { de: 'Räume melden', en: 'Rooms reporting' },
  tileStockLow: { de: 'Artikel unter Minimum', en: 'Items below min' },
  tileProcurement: { de: 'Offene PR / PO', en: 'Open PR / PO' },
  tileAssets: { de: 'Assets im Betrieb', en: 'Assets operational' },
  tileAssetsFault: { de: 'Assets gestört', en: 'Assets faulted' },

  // Period filter (SEN-AN-005)
  periodToday: { de: 'Heute', en: 'Today' },
  period7d: { de: '7 Tage', en: '7 days' },
  period30d: { de: '30 Tage', en: '30 days' },
  period6m: { de: '6 Monate', en: '6 months' },

  // Trends section (period control scopes charts + timeline)
  trendsTitle: { de: 'Trends', en: 'Trends' },
  ariaPeriod: { de: 'Zeitraum', en: 'Period' },
  ariaKind: { de: 'Ereignistyp', en: 'Event type' },
  refreshing: { de: 'Wird aktualisiert …', en: 'Updating…' },
  chartError: { de: 'Trenddaten konnten nicht geladen werden.', en: 'Could not load the trend data.' },

  // Charts
  chartEvents: { de: 'Ereignisse pro Tag', en: 'Events per day' },
  chartStock: { de: 'Lagerbewegungen pro Tag', en: 'Stock movements per day' },
  chartEventsEmpty: {
    de: 'Keine Ereignisse im Zeitraum.',
    en: 'No events in this period.',
  },
  chartStockEmpty: {
    de: 'Keine Lagerbewegungen im Zeitraum.',
    en: 'No stock movements in this period.',
  },
  seriesIncidents: { de: 'Störungen', en: 'Incidents' },
  seriesAlarms: { de: 'Alarme', en: 'Alarms' },
  seriesChanges: { de: 'Changes', en: 'Changes' },
  seriesIssues: { de: 'Entnahmen', en: 'Issues' },
  seriesReceipts: { de: 'Zugänge', en: 'Receipts' },

  // Timeline
  timelineTitle: { de: 'Aktivitätsverlauf', en: 'Activity timeline' },
  timelineEmpty: { de: 'Keine Ereignisse im Zeitraum.', en: 'No events in this period.' },
  timelineEmptyHint: {
    de: 'Neue Störungen und Changes, Alarme, der aktuelle Asset-Status und Lagerbewegungen erscheinen hier.',
    en: 'New incidents and changes, raised alarms, current asset status and stock movements appear here.',
  },
  timelineKindEmpty: {
    de: 'Keine Ereignisse dieses Typs im Zeitraum.',
    en: 'No events of this type in this period.',
  },
  timelineError: {
    de: 'Der Aktivitätsverlauf konnte nicht geladen werden.',
    en: 'Could not load the activity timeline.',
  },
  timelineErrorHint: {
    de: 'Der Server hat die Anfrage abgelehnt. Die Ansicht füllt sich automatisch, sobald er wieder antwortet.',
    en: 'The server rejected the request. This view fills in on its own once the server answers again.',
  },
  timelineOpen: { de: '{kind} {ref} — {module} öffnen', en: '{kind} {ref} — open {module}' },
  moduleIncidents: { de: 'Störungen', en: 'Incidents' },
  moduleChanges: { de: 'Changes', en: 'Changes' },
  moduleSoc: { de: 'SOC', en: 'SOC' },
  moduleAssets: { de: 'Asset-Register', en: 'Asset register' },
  moduleWarehouse: { de: 'Lager', en: 'Warehouse' },
  stockReceipt: { de: 'Zugang', en: 'Receipt' },
  stockConsumption: { de: 'Entnahme', en: 'Issue' },
  stockCorrection: { de: 'Korrektur', en: 'Correction' },
  stockTransferIn: { de: 'Umlagerung (Eingang)', en: 'Transfer in' },
  stockTransferOut: { de: 'Umlagerung (Ausgang)', en: 'Transfer out' },
  stockStocktake: { de: 'Inventur', en: 'Stocktake' },
  filterAll: { de: 'Alle', en: 'All' },
  showMore: { de: '{count} weitere anzeigen', en: 'Show {count} more' },
  exportCsv: { de: 'CSV exportieren', en: 'Export CSV' },
  kindIncident: { de: 'Störung', en: 'Incident' },
  kindChange: { de: 'Change', en: 'Change' },
  kindAlarm: { de: 'Alarm', en: 'Alarm' },
  kindAsset: { de: 'Asset', en: 'Asset' },
  kindStock: { de: 'Lager', en: 'Stock' },
} as const satisfies Namespace;
